// extracted by mini-css-extract-plugin
export default {"container":"PlaceHolder_container__AGpaf"};